import React, {useEffect} from "react";


const Escalera = ()=> {



  const ar = [
   ["rgba(188, 158, 130, 0.4)",[]],  // Warm Sand (Beige-Brown)
    ["rgba(110, 122, 94, 0.4)",[1]],  // Muted Sage (Green-Grey)
    ["rgba(166, 114, 92, 0.4)",[]] , // Terracotta Clay (Dusty Orange)
    ["rgba(95, 103, 115, 0.4)",[]],  // River Stone (Cool Slate)
    ["rgba(140, 131, 118, 0.4)",[]]// Muted Lavender
  ];

  const meses = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ];
  useEffect(()=>{



  },[])
  return (
    <div className='container text-center p-2' style={{maxWidth:"640px",margin:'auto'}}>
      <span className="h4">Escalera, Felipe Valls, 69</span><br/>
      <span className="h6">Calendario</span>
      <div className="" >
        <div className="row">
          {

            meses.filter((aa,ii)=>ii<6 && aa).map((aa, ii) => (
              <div className="col p-1"><span >{aa.split('').slice(0,3).join('')}</span>
              </div>
            ))
          }
        </div>
        {ar.map((a, i) => (

          <div className="row">
            {

              meses.filter((aa,ii)=>ii<6 && aa).map((aa, ii) => (
                <div className="col  p-1 m-1 " style={{backgroundColor:a[0]}} dangerouslySetInnerHTML={{__html : a[1][ii]==1 ? '+' : '<span>&nbsp;</span>'}} />

              ))
            }
          </div>


        ))}
<hr/>
        <div className="row">
          {

            meses.filter((aa,ii)=>ii>=6 && aa).map((aa, ii) => (
              <div className="col p-1"><span >{aa.split('').slice(0,3).join('')}</span>
              </div>
            ))
          }
        </div>
        {ar.map((a, i) => (

          <div className="row">
            {

              meses.filter((aa,ii)=> ii>=6 && aa).map((aa, ii) => (
                <div className="col p-1 m-1 "  style={{backgroundColor:a[0]}} >&nbsp;
                </div>
              ))
            }
          </div>


        ))}
        <hr/>

        {ar.map((a, i) => (
          <div className="row">
            <div className="col-2 p-1"> <div style={{backgroundColor: a[0]}}>  &nbsp;</div></div>
            <div className="col-10 text-left" >  Piso #{5-i}</div>
          </div>
        ))
        }

    </div>

</div>
  );
}

export default Escalera;
